// extracted by css-extract-rspack-plugin
export default {"cls1":"LoggedOutDiscoveryPage-cls1_dzd","cls2":"LoggedOutDiscoveryPage-cls2_GoP LoggedOutDiscoveryPage-cls1_dzd"};